<script lang="ts">
	import { Collapse, Navbar, NavbarBrand, NavbarToggler } from "@sveltestrap/sveltestrap";
	import NavLinks from "./NavLinks.svelte";

	let isOpen = $state(false);

	function handleUpdate(event: CustomEvent<boolean>) {
		isOpen = event.detail;
	}
</script>

<!-- Desktop: plain div, no Collapse, no transition -->
<Navbar color="dark" dark expand="md" container={false} class="w-100 d-none d-md-flex">
	<NavbarBrand href="/" class="ms-2">AI Slides</NavbarBrand>
	<div class="navbar-collapse collapse show d-flex">
		<NavLinks />
	</div>
</Navbar>

<!-- Mobile: Collapse-based toggler, hidden at ≥md -->
<Navbar color="dark" dark expand="md" container={false} class="w-100 d-md-none">
	<NavbarBrand href="/" class="ms-2">AI Slides</NavbarBrand>
	<NavbarToggler on:click={() => (isOpen = !isOpen)} class="me-2" />
	<Collapse {isOpen} color="dark" navbar expand="md" on:update={handleUpdate} class="bg-dark mt-2">
		<NavLinks />
	</Collapse>
</Navbar>
